import { LongPollingClient } from "@infrastructure/clients/polling/clients/base/longPolling.client";
import { ShortPollingClient } from "@infrastructure/clients/polling/clients/base/shortPolling.client";
import { BASE_URL } from "@infrastructure/clients/http/config";
import type { LongPollingOptions } from "@infrastructure/clients/polling/clients/base/longPolling.client";
import type { ShortPollingOptions } from "@infrastructure/clients/polling/clients/base/shortPolling.client";

export class UpdatesLongPollingClient extends LongPollingClient {
  baseUrl = BASE_URL;

  async startUpdatesPolling(options: LongPollingOptions): Promise<() => void> {
    return this.startPolling("/api/updates", options);
  }
}

export class UpdatesShortPollingClient extends ShortPollingClient {
  baseUrl = BASE_URL;

  startStatusPolling(options: ShortPollingOptions): () => void {
    return this.startPolling("/api/status", options);
  }
}

